<template>
    <div class="container">
        <order-list :orders="pastOrders"></order-list>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: 'past-orders',
        data() {
            return {}
        },
        computed: Object.assign({}, mapGetters(['pastOrders'])),
    };
</script>



// WEBPACK FOOTER //
// PastOrders.vue?34f182b2